import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { FactoringCalculationRequest, FactoringCalculationResponse, FactoringOperationDetailDTO, FactoringOperationNewMinuteResponseDTO, NewInvoice, NewInvoiceOperationResponseDTO, RecalculateInvoiceOperationDTO } from '../interface/invoice-operation.interface';
import { ActionResponseDTO } from './../../../../common/interfaces/action-result.interface';
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class FactoringOperationsService {

  constructor(private http: HttpClient) {}
  
  newInvoice(value:NewInvoice) : Observable<NewInvoiceOperationResponseDTO>
  {
    console.log(value)
    const endpoint = `${environment.apiUrl}/FactoringOperation/new`;
    return this.http.post<NewInvoiceOperationResponseDTO>(endpoint,value);
  }

  /*
   * Metodo para realizar consulta API para registrar una nueva minuta a una operacion de factoring
   */
  registerInvoiceOperationMinuteRequest(invoiceOperationId: number): Observable<ActionResponseDTO<FactoringOperationNewMinuteResponseDTO>>
  {
    const endpoint = `${environment.apiUrl}/FactoringOperation/${invoiceOperationId}/Minute/New`;
    return this.http.post<ActionResponseDTO<FactoringOperationNewMinuteResponseDTO>>(endpoint, null);
  }

  public calculateInvoiceOperation(request: FactoringCalculationRequest): Observable<ActionResponseDTO<FactoringCalculationResponse>> {
    const endpoint = `${environment.apiUrl}/FactoringOperation/calculate`;
    return this.http.post<ActionResponseDTO<FactoringCalculationResponse>>(endpoint, request);
  }

  recalculateInvoiceOperation(invoiceOperationId: bigint, request: RecalculateInvoiceOperationDTO){
    const endpoint = `${environment.apiUrl}/FactoringOperation/${invoiceOperationId}/recalculate`;
    return this.http.put<ActionResponseDTO<any>>(endpoint, request);
  }

  getFactoringOperationById(id: bigint): Observable<FactoringOperationDetailDTO> {
    const endpoint = `${environment.apiUrl}/FactoringOperation/${id}`;
    return this.http.get<FactoringOperationDetailDTO>(endpoint);
  }
}
